import { render, staticRenderFns } from "./word-item.vue?vue&type=template&id=476c64b0&lang=pug&"
import script from "./word-item.vue?vue&type=script&lang=js&"
export * from "./word-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports